module.exports = __webpack_public_path__ + "img/9788954671064.a8bffe85.jpg";